import { Box, Typography } from "@mui/material";
import PrivacyPolicyContent from "../components/PrivacyPolicyContent";

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <Box
      sx={{
        maxWidth: "900px",
        margin: "auto",
        pt: "80px",
        pb: "80px",
        pl: "20px",
        pr: "20px",
      }}
    >
      <Typography variant="h4">Politika privatnosti</Typography>
      <PrivacyPolicyContent />
    </Box>
  );
};
